<script>
export default {
    data() {
        return {
        }
    },
    props: {
        quizOptions: {
            type: Object,
            default(rawProp) {
                return rawProp.quizOptions ? rawProp.quizOptions : {};
            },
            required: false,
        },
    },
    methods: {
    }
}
</script>
<template>
    <div class="quiz-meta-data" v-if="quizOptions">
        <div class="quiz-meta-wrapper">
            <span v-if="quizOptions.quizClues">
                <span>Quiz Clue: </span>
                <span>{{ quizOptions.quizClues }}</span>
                <span class="meta-spacer">|</span>
            </span>
            <span v-if="quizOptions.total_tries">
                <span>Total tries: </span>
                <span>{{ quizOptions.total_tries }}</span>
                <span class="meta-spacer">|</span>
            </span>
            <span v-if="quizOptions.average && quizOptions.average.average_score && quizOptions.average.max_score">
                <span>Average Score: {{ quizOptions.average.average_score }} out of {{ quizOptions.average.max_score }}  ({{ quizOptions.average.percentage }}%)</span>
            </span>
        </div>
    </div>
</template>